/**
 * Facet Size Merge
 * Merges duplicate size filter values caused by translation apps
 * replacing dots with commas (e.g. "7.5 UK/41 1/3 EU" vs "7,5 UK/41 1/3 EU")
 *
 * How it works:
 * 1. Finds all size filter checkboxes (values containing UK/, CM/, or EU)
 * 2. Groups duplicates by normalizing commas to dots
 * 3. Hides the comma variant's <li>
 * 4. Combines the product counts
 * 5. When the dot variant is checked/unchecked, also checks/unchecks the comma variant
 *    so both variant products appear in filtered results
 */
(function () {
  function normalizeSize(val) {
    // Replace commas with dots for comparison
    return val.replace(/,/g, '.');
  }

  function isSizeValue(val) {
    return /UK\/|CM\/|EU/.test(val);
  }

  function mergeSizeFilters(container) {
    if (!container) return;

    const forms = container.querySelectorAll('form[is="facet-form"]');
    forms.forEach(function (form) {
      // Get all filter checkbox inputs
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      const sizeMap = {}; // normalized value -> { dot: input, comma: input }

      checkboxes.forEach(function (cb) {
        var val = cb.value;
        if (!isSizeValue(val)) return;

        var normalized = normalizeSize(val);
        if (!sizeMap[normalized]) {
          sizeMap[normalized] = [];
        }
        sizeMap[normalized].push(cb);
      });

      // Normalize labels and merge duplicates
      Object.keys(sizeMap).forEach(function (key) {
        var group = sizeMap[key];

        // Fix display label: replace commas with dots in all size labels
        group.forEach(function (cb) {
          if (cb.value !== key) {
            // This value has a comma — fix its visible label
            var li = cb.closest('li') || cb.closest('.filter-item');
            if (li) {
              var labelSpan = li.querySelector('.reversed-link__text');
              if (labelSpan && labelSpan.textContent !== key) {
                labelSpan.textContent = key;
              }
            }
          }
        });

        if (group.length < 2) return;

        // Find the "primary" (dot version) and "secondary" (comma version)
        var primary = null;
        var secondaries = [];

        group.forEach(function (cb) {
          // The dot version is primary; if both have dots or both have commas, pick first
          if (cb.value === key) {
            primary = cb;
          } else {
            secondaries.push(cb);
          }
        });

        // If no exact dot match found, use first as primary
        if (!primary) {
          primary = group[0];
          secondaries = group.slice(1);
        }

        var primaryLi = primary.closest('li') || primary.closest('.filter-item');
        var primaryCountEl = primaryLi ? primaryLi.querySelector('.count') : null;

        secondaries.forEach(function (secondary) {
          var secondaryLi = secondary.closest('li') || secondary.closest('.filter-item');
          if (!secondaryLi) return;

          // Combine counts
          if (primaryCountEl) {
            var secondaryCountEl = secondaryLi.querySelector('.count');
            if (secondaryCountEl) {
              var pCount = parseInt(primaryCountEl.textContent) || 0;
              var sCount = parseInt(secondaryCountEl.textContent) || 0;
              primaryCountEl.textContent = pCount + sCount;
            }
          }

          // Hide the secondary
          secondaryLi.style.display = 'none';
          secondaryLi.classList.add('size-merge-hidden');

          // If secondary was active, also activate primary
          if (secondary.checked && !primary.checked) {
            primary.checked = true;
          }

          // Sync: when primary changes, also change secondary
          primary.addEventListener('change', function () {
            if (secondary.checked !== primary.checked) {
              secondary.checked = primary.checked;
            }
          });

          // If secondary somehow gets changed (e.g. URL state), sync back
          secondary.addEventListener('change', function () {
            if (primary.checked !== secondary.checked) {
              primary.checked = secondary.checked;
            }
          });
        });
      });
    });
  }

  function run() {
    mergeSizeFilters(document);
  }

  // Run on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run after AJAX filter updates (FacetForm re-renders the filter containers)
  document.addEventListener('collection:rerendered', function () {
    // Small delay to let DOM update complete
    setTimeout(run, 100);
  });
})();